<template>
  <router-view />
</template>

<script>
import { onMounted, onUnmounted, watch } from 'vue'
import { useBrowserSecurity } from '@/composables/useBrowserSecurity'
import { useSessionMonitor } from '@/composables/useSessionMonitor'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'App',
  setup() {
    const { enableSecurity, disableSecurity } = useBrowserSecurity()
    const { startSessionMonitoring, stopSessionMonitoring } = useSessionMonitor()
    const authStore = useAuthStore()
    let cleanupDevTools = null

    // Enable security measures on mount
    onMounted(() => {
      cleanupDevTools = enableSecurity()
    })

    // Watch for authentication changes
    watch(() => authStore.isAuthenticated, (newValue) => {
      if (newValue) {
        // User logged in - disable security measures and start session monitoring
        disableSecurity()
        startSessionMonitoring()
        if (cleanupDevTools) {
          cleanupDevTools()
          cleanupDevTools = null
        }
      } else {
        // User logged out - enable security measures and stop session monitoring
        stopSessionMonitoring()
        cleanupDevTools = enableSecurity()
      }
    }, { immediate: true })

    // Cleanup on unmount
    onUnmounted(() => {
      disableSecurity()
      stopSessionMonitoring()
      if (cleanupDevTools) {
        cleanupDevTools()
      }
    })

    return {}
  }
}
</script>

<style>
/* Disable text selection for non-authenticated users */
.no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}

/* Hide scrollbars to prevent some dev tool detection methods */
.secure-content::-webkit-scrollbar {
  display: none;
}

.secure-content {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Prevent highlighting and copying */
.secure-content * {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

/* Print protection */
@media print {
  .no-print {
    display: none !important;
  }
}
</style>
